<template>
  <footer class="landing-footer">
    <section class="contact-block" aria-label="Contact us">
      <div class="support-icon" aria-hidden="true"></div>
      <div>
        <h2>Contact Us</h2>
        <a href="tel:+15617101663" class="contact-link">
          <span class="phone-icon" aria-hidden="true"></span>
          <span>561-710-1663</span>
        </a>
        <a href="mailto:info@checkmarq.com" class="contact-link">
          <span class="mail-icon" aria-hidden="true"></span>
          <span>info@checkmarq.com</span>
        </a>
      </div>
    </section>

  </footer>
</template>

<script>
export default {
  name: 'LandingFooter',
}
</script>

<style scoped lang="scss">
.landing-footer {
  align-items: center;
  background: #052a61;
  color: #ffffff;
  display: grid;
  gap: 36px;
  grid-template-columns: minmax(0, 480px);
  justify-content: center;
  min-height: 250px;
  padding: 42px 58px;
}

.contact-block {
  align-items: center;
  display: flex;
  gap: 24px;
}

.contact-block {
  min-height: 118px;
  padding-right: 40px;
}

.support-icon {
  border: 1px solid rgba(255, 255, 255, 0.82);
  border-radius: 50%;
  height: 68px;
  position: relative;
  width: 68px;
}

.support-icon::before {
  border: 3px solid #ffffff;
  border-bottom: 0;
  border-radius: 24px 24px 0 0;
  content: '';
  height: 28px;
  left: 15px;
  position: absolute;
  top: 18px;
  width: 34px;
}

.support-icon::after {
  border: 3px solid #ffffff;
  border-radius: 4px;
  content: '';
  height: 14px;
  left: 13px;
  position: absolute;
  top: 35px;
  width: 9px;
}

h2 {
  color: #ffffff;
  font-size: 19px;
  line-height: 1.2;
  margin-bottom: 18px;
}

.contact-link {
  align-items: center;
  color: #ffffff;
  display: flex;
  font-size: 17px;
  gap: 14px;
  line-height: 1.3;
  margin-top: 12px;
  text-decoration: none;
}

.phone-icon,
.mail-icon {
  display: inline-block;
  height: 18px;
  position: relative;
  width: 18px;
}

.phone-icon::before {
  border: 3px solid #ffffff;
  border-left-width: 6px;
  border-radius: 12px 4px 12px 4px;
  content: '';
  height: 14px;
  left: 2px;
  position: absolute;
  top: 1px;
  transform: rotate(-32deg);
  width: 9px;
}

.mail-icon {
  border: 2px solid #ffffff;
  border-radius: 1px;
}

.mail-icon::before,
.mail-icon::after {
  background: #ffffff;
  content: '';
  height: 2px;
  left: 1px;
  position: absolute;
  top: 7px;
  transform: rotate(34deg);
  width: 12px;
}

.mail-icon::after {
  left: 5px;
  transform: rotate(-34deg);
}

@media only screen and (max-width: 1120px) {
  .landing-footer {
    grid-template-columns: 1fr;
    padding: 38px 30px;
  }

  .contact-block {
    min-height: 0;
    padding-right: 0;
  }
}

@media only screen and (max-width: $mobile-size) {
  .landing-footer {
    padding: 34px 22px;
  }

  .contact-block {
    align-items: flex-start;
  }

}
</style>
